import { useMutation } from '@apollo/client/react';
import { gql } from '@apollo/client';
import { toast } from 'sonner';

export const DELETE_USER_MUTATION = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id) {
      user {
        id
      }
    }
  }
`;

export function useDeleteUser(options?: { onCompleted?: () => void; onError?: (error: any) => void }) {
  const [deleteUserMutation, { loading }] = useMutation(DELETE_USER_MUTATION, {
    onCompleted: options?.onCompleted,
    onError: (error: any) => {
      if (options?.onError) {
        options.onError(error);
      } else {
        const message = error.graphQLErrors?.[0]?.message || error.message || 'Falha ao excluir usuário';
        toast.error(message);
      }
    },
  });

  const deleteUser = (id: string) => {
    return deleteUserMutation({
      variables: { id },
    });
  };

  return { deleteUser, loading };
}
